import React from 'react';
import enhance from './CampaignDeals.enhancer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import ActiveDeals from './ActiveDeals';
import ContentComplete from './ContentComplete';
import CompleteDeals from './CompleteDeals';
import SwipeableViews from 'react-swipeable-views';
import ViewProposal from '../../deals/proposals/ViewProposal';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class ReviewProposals extends React.Component {
  constructor() {
    super();

    this.initialState = {
      allDeals: [],
      activeDeals: [],
      completedDeals: [],
      loadingUserData: false,
      index: 0
    };

    this.state = {
      ...this.initialState
    };
  }

  isActiveDealsSelected = page => {
    return page === 7;
  };

  isContentCompleteDealsSelected = page => {
    return page === 8;
  };

  isCompleteDealsSelected = page => {
    return page === 9;
  };

  navigateToActiveDeals() {
    this.props.history.push(`/campaigns/${this.props.campaign.id}/active`);
  }

  navigateToContentCompleteDeals() {
    this.props.history.push(
      `/campaigns/${this.props.campaign.id}/contentComplete`
    );
  }

  navigateToCompletedDeals() {
    this.props.history.push(`/campaigns/${this.props.campaign.id}/completed`);
  }

  handleNextClick() {
    const newIndex = this.state.index + 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackClick() {
    const newIndex = this.state.index - 1;
    this.setState({
      index: newIndex
    });
  }

  openViewProposal(deal) {
    this.setState({
      currentDealProposal: deal,
      viewPropsalIsOpen: true
    });
  }

  closeViewProposal() {
    this.setState({
      currentDealProposal: {},
      viewPropsalIsOpen: false
    });
  }

  getStepContent(params) {
    const { key } = params;
    switch (this.state.index) {
      case 0:
        return (
          <Paper className={this.props.classes.layout}>
            <div className={this.props.classes.proposalHeaderContainer}>
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isActiveDealsSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToActiveDeals()}
              >
                Active{' '}
                {this.props.activeDeals && this.props.activeDeals.length > 0
                  ? `(${this.props.activeDeals.length})`
                  : ''}
              </div>
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isContentCompleteDealsSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToContentCompleteDeals()}
              >
                Content Complete{' '}
                {this.props.contentCompleteDeals &&
                this.props.contentCompleteDeals.length > 0
                  ? `(${this.props.contentCompleteDeals.length})`
                  : ''}
              </div>
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isCompleteDealsSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToCompletedDeals()}
              >
                Completed{' '}
                {this.props.completeDeals && this.props.completeDeals.length > 0
                  ? `(${this.props.completeDeals.length})`
                  : ''}
              </div>
            </div>
            <Divider />
            <div className={this.props.classes.reviewProposalsContentContainer}>
              {this.props.page === 7 && (
                <ActiveDeals
                  campaign={this.props.campaign}
                  deals={this.props.activeDeals}
                  openViewProposal={this.openViewProposal.bind(this)}
                />
              )}
              {this.props.page === 8 && (
                <ContentComplete
                  campaign={this.props.campaign}
                  deals={this.props.contentCompleteDeals}
                  openViewProposal={this.openViewProposal.bind(this)}
                />
              )}
              {this.props.page === 9 && (
                <CompleteDeals
                  campaign={this.props.campaign}
                  deals={this.props.completeDeals}
                  openViewProposal={this.openViewProposal.bind(this)}
                />
              )}
            </div>
          </Paper>
        );
      case 1:
        return <div>2</div>;
    }
  }

  render() {
    const {
      classes,
      page,
      deals,
      activeDeals,
      contentCompleteDeals,
      completeDeals
    } = this.props;
    const { currentDealProposal, viewPropsalIsOpen } = this.state;

    return (
      <React.Fragment>
        <VirtualizeSwipeableViews
          style={{ width: '100%' }}
          slideCount={2}
          index={this.state.index}
          slideRenderer={this.getStepContent.bind(this)}
          disabled={true}
        />
        <ViewProposal
          deal={currentDealProposal}
          open={viewPropsalIsOpen}
          closeClick={this.closeViewProposal.bind(this)}
          showButtons={false}
        />
      </React.Fragment>
    );
  }
}

export default enhance(ReviewProposals);



// WEBPACK FOOTER //
// ./src/components/campaign/deals/CampaignDeals.js